module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "pay-main-warp column"
  }, [_c('div', {
    staticClass: "lists-box row m-column"
  }, [_c('div', {
    staticClass: "setUrl"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    on: {
      "click": _vm.goback
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setTitle"
  }, [_vm._v("\n          問い合わせフォーム\n        ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "feedContent"
  }, [_c('div', {
    staticClass: "feed-title"
  }, [_vm._v("\n            お問合せカテゴリー\n          ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "お問合せカテゴリーを選択"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "feed-title",
    staticStyle: {
      "margin-top": "47px"
    }
  }, [_vm._v("\n            お問い合わせ内容\n          ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "resize": "none",
      "rows": 15,
      "placeholder": "お問合せ内容を入力"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    staticClass: "btn_confirm",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.sendMail()
      }
    }
  }, [_vm._v("送信")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setContent"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n            もっとワクワークする世の中を\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36058a7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/feedback/Feedback.vue
// module id = 886
// module chunks = 1